module.exports = __webpack_public_path__ + "static/media/icon-money-arrow.b4386520.svg";